import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { DropTarget } from 'react-dnd'
import SortItem from './SortItem'
import cn from 'classnames'

const target = {
  drop (props, monitor, component) {
    const {id} = props
    const source = monitor.getItem()
    if (source.listId !== id) {
      component.addItem(source.item)
      component.drop()
    }

    return {
      listId: id
    }
  }
}

@DropTarget(props => props.itemType, target, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
export default class SortContainer extends Component {
  static propTypes = {
    itemType: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    didSort: PropTypes.func.isRequired,
    renderItem: PropTypes.func.isRequired,
    id: PropTypes.string
  }

  state = {
    items: this.props.items
  }

  componentWillReceiveProps (props) {
    if (props.items !== this.props.items) {
      this.setState({items: props.items})
    }
  }

  addItem = item => {
    this.setState(update(this.state, {
      items: {
        $push: [ item ]
      }
    }))
  }

  removeItem = index => {
    this.setState(update(this.state, {
      items: {
        $splice: [
          [index, 1]
        ]
      }
    }))
  }

  moveItem = (dragIndex, hoverIndex) => {
    const dragItem = this.state.items[dragIndex]

    // console.log(dragIndex, hoverIndex)
    // console.log(dragItem)

    this.setState(update(this.state, {
      items: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragItem]
        ]
      }
    }))
  }

  drop = () => {
    this.props.didSort(this.state.items)
  }

  render () {
    const {connectDropTarget, renderItem, itemType, didSort, items,
      canDrop, isOver, id, ...props} = this.props
    const active = canDrop && isOver
    const className = cn(props.className, 'sort-container', {active})

    return connectDropTarget(
      <div {...props} className={className}>
        {this.props.children}
        {this.state.items.map((item, i) => {
          if (!item) return null
          return <SortItem key={item.id || i}
            itemType={itemType}
            listId={id}
            index={i}
            item={item}
            removeItem={this.removeItem}
            moveItem={this.moveItem}
            onDrop={this.drop}
          >
            {renderItem(item)}
          </SortItem>
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/SortContainer.js